import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
export default {
  name: "Live",
  data: function data() {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      bjy_period_id: this.$route.query.bjy_period_id,
      type: this.$route.query.type,
      last_time: 0,
      meeting_id: this.$route.query.meeting_id
    };
  },
  methods: {
    handle: function handle(url) {
      document.getElementById("frame").src = url;
    },
    onMessgae: function () {
      var _onMessgae = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!event.data.totalTime || !this.bjy_period_id)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.last_time == event.data.currentTime)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                this.last_time = event.data.currentTime;
                _context.next = 7;
                return this.$http.post("/api/app/course/playBack", {
                  course_basis_id: parseInt(this.course_id),
                  course_periods_id: parseInt(this.bjy_period_id),
                  total_time: parseInt(event.data.totalTime),
                  last_time: parseInt(event.data.currentTime),
                  current_time: 120
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onMessgae(_x) {
        return _onMessgae.apply(this, arguments);
      }

      return onMessgae;
    }(),
    play: function () {
      var _play = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var course_type, liveData, data, params, _data, frame;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                course_type = this.$route.query.course_type;

                if (!(course_type == 1)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return this.$http.get("/api/app/oto/getLiveRoomCode/" + this.course_id + "/0", {}, {
                  onError: function onError() {
                    _this.$router.push({
                      name: "Home"
                    });
                  }
                });

              case 4:
                liveData = _context2.sent;
                _context2.next = 25;
                break;

              case 7:
                if (!(course_type == 2 || course_type == 3 || course_type == 4 || course_type == 15)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 10;
                return this.$http.get("/api/app/getPcRoomCode/course_id=" + this.course_id + "/chapter_id=" + this.period_id, {
                  type: this.type,
                  arrange_id: this.$route.query.arrange_id
                }, {
                  onError: function onError() {
                    _this.$router.push({
                      name: "Home"
                    });
                  }
                });

              case 10:
                data = _context2.sent;
                liveData = data.chapterInfo;
                _context2.next = 25;
                break;

              case 14:
                if (!(course_type == "meeting")) {
                  _context2.next = 24;
                  break;
                }

                //班会
                params = {};
                params.type = this.type;
                params.meeting_id = this.meeting_id;
                _context2.next = 20;
                return this.$http.get("/api/app/getPcRoomCode/course_id=" + this.course_id + "/chapter_id=" + this.period_id, params);

              case 20:
                _data = _context2.sent;
                liveData = _data;
                _context2.next = 25;
                break;

              case 24:
                return _context2.abrupt("return");

              case 25:
                frame = document.getElementById("frame");
                frame.allow = "microphone *;camera *;midi *;encrypted-media *;autoplay *;fullscreen *;display-capture *;screen-wake-lock *;";
                document.getElementById("frame").src = liveData.web_url;

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.bjy_period_id) {
      window.addEventListener("message", this.onMessgae);
    }

    this.$nextTick(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this2.play();

              $('#meiqia-container').css('display', 'none'); //隐藏联系客服

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
  },
  beforeDestroy: function beforeDestroy() {
    $('#meiqia-container').css('display', 'block'); //销毁前显示客服

    if (this.bjy_period_id) {
      window.removeEventListener("message", this.onMessgae);
    }
  }
};